import React, { FunctionComponent } from 'react';

import ErrorBoundary from '@justgiving/error-boundary';
import Loading from '@justgiving/loading';
import { captureException } from '@sentry/browser';

import { useApp } from '../../hooks';

export const LazyLoader: FunctionComponent = ({ children }) => {
  const { isSSR } = useApp();

  if (isSSR) {
    return null;
  }

  return (
    <ErrorBoundary fallbackContent={null} onError={captureException}>
      <React.Suspense fallback={<Loading />}>{children}</React.Suspense>
    </ErrorBoundary>
  );
};
